import ReportDrawer from '../../../constants/ReportDrawer';
import SidebarOpen from '../../../constants/SidebarOpen';
import { useSidebar } from '../../../helpers/sidebarClose';
import CircleBtn from '../../../constants/CircleBtn';
import ReportHeader from '../../../constants/ReportHeader';
import { useReactToPrint } from "react-to-print";
import { useEffect, useRef, useState } from 'react';
import DayBookFormView from '../../../components/account/reports/day_book/DayBookFormView';
import DayBookListView from '../../../components/account/reports/day_book/DayBookListView';
import PrintDayBookListView from '../../../components/account/reports/day_book/PrintDayBookListView';

const DayBookReportCreateListView = ({ setIconsButton }: { setIconsButton: any }) => {
    const { isOpen, toggleSidebar, closeSidebar } = useSidebar('day_book_rpt');
    const [onDayBookReport, setOnDayBookReport] = useState([]);
    const componentListRef = useRef<HTMLDivElement | null>(null);

    const handlePrintCard = useReactToPrint({
        content: () => componentListRef.current!,
    });

    useEffect(() => {
        setIconsButton(<CircleBtn onClick={handlePrintCard} />);
        return () => setIconsButton(null);
    }, []);

    useEffect(() => {
        if (!isOpen) {
            toggleSidebar();
        }
    }, [isOpen, toggleSidebar]);
    return (
        <>
            <SidebarOpen onClick={toggleSidebar} />
            <ReportDrawer header={<ReportHeader label='Day Book Reports' />} open={isOpen} onClose={closeSidebar}>
                <DayBookFormView setOnDayBookReport={setOnDayBookReport} />
            </ReportDrawer>
            <DayBookListView onDayBookReport={onDayBookReport} />
            <div className='hidden'>
                <div ref={componentListRef}>
                    <PrintDayBookListView onDayBookReport={onDayBookReport} />
                </div>
            </div>
        </>
    );
}

export default DayBookReportCreateListView;
